/* helper files for validation and cleaning of input */

function isString(t) {
	return t && typeof t === 'string';
}

function isNumber(t) {
	return typeof t === 'number';
}

function isNullOrUndefined(t) {
	return t === null || typeof t === 'undefined';
}

function isStringOrNumber(t) {
	return typeof t === 'string' || typeof t === 'number';
}

function containsOnlyDigits(t) {
	const str = typeof t === 'number' ? t.toString() : t;
	const nums = new RegExp(/^\+?[0-9]+$/);
	return nums.test(str);
}
function hasGreekCurrencyFormat(t) {
	if (!isString(t)) {
		// eslint-disable-next-line
		console.warn('string-num-clean: hasGreekCurrencyFormat: input value is not a string', t);
		return false;
	}
	// important: (10,4).toString() === '4'
	// const str = typeof t === 'number' ? t.toString() : t;
	// Modified example from regexlib to use only decimal-point instead of comma.
	// http://www.regexlib.com/Search.aspx?k=decimal+digit&c=-1&m=-1&ps=20
	// Description
	// Matches a currency value (without currency symbol) using , for decimal digits separator
	// Matches
	// 0.12 | 100 | 100.1
	// Non-Matches
	// 0,123 | 10,1 | ,23
	const decimalNumsWithDot = new RegExp(/^[0-9]+(\.[0-9]{1,2})?$/);
	return decimalNumsWithDot.test(t);
}

function twoOrNoDecimals(v) {
	// format a string or number to string
	// to '#' or '#.##'
	const t = isNumber(v) ? v.toString() : v;
	if (!isString(t)) {
		// eslint-disable-next-line
		console.warn('string-num-clean:twoOrNoDecimals: only string or number allowed', v);
		return '';
	}
	if (!hasGreekCurrencyFormat(t)) {
		// eslint-disable-next-line
		console.warn('string-num-clean: twoOrNoDecimals: input value has not valid currencyformat', t);
		return '';
	}
	// the format is now #.## or #.# or #
	// like 0.12 100 or 100.1
	// get the decimal part:
	const parts = t.split('.');
	const decimals = parts.length === 2 ? parts[1] : null;
	if (!decimals) return t;
	const oneDecimal = decimals.length === 1;
	// if one decimal exist, another zero is added
	// if two decimals exist, they are returned if they not are zero.
	const setTwoDecimals = oneDecimal ? `${decimals}0` : `${decimals}`;
	const newDecimals = setTwoDecimals[0] === '0' && setTwoDecimals[1] === '0' ? '' : `.${setTwoDecimals}`;
	const assembled = `${parts[0]}${newDecimals}`;
	return assembled;
}

function containsOnlyLetters(t) {
	if (!isString(t)) return false;
	const letters = new RegExp(/^\+?[a-zA-ZåäöÅÄÖ]+$/);
	return letters.test(t);
}

function containsOnlyDigitsOrLetters(t) {
	const nums = new RegExp(/^\+?[0-9a-zA-Z]+$/);
	return nums.test(t);
}

function hasTwoWords(t) {
	// TODO preliminary method of validation normally applied to cardowner
	// desktopsite: customWordCount 2
	const twoWords = new RegExp(/^[a-zåäöA-ZÅÄÖ]{1,20}\s[a-zåäöA-ZÅÄÖ]{1,20}$/);
	return twoWords.test(t);
}
function hasStringLengthOf(t, n) {
	const str = typeof t === 'number' ? t.toString() : t;
	return str && str.length && str.length === n;
}
function hasStringLengthMinMax(t, min = 0, max) {
	const str = typeof t === 'number' ? t.toString() : t;
	if (max === 0) {
		return false;
	}
	if (max) {
		return Boolean(str && str.length && str.length >= min && str.length <= max);
	}
	return str && str.length && str.length >= min;
}

function doesNotContainNonLatinCodepoints(s) {
	/* eslint-disable no-control-regex */
	const hasNonLatinChars = new RegExp(/[^\u0000-\u00ff]/).test(s);
	return !hasNonLatinChars;
	/* eslint-enable no-control-regex */
}

function beginsWithHyphen(t) {
	return new RegExp(/^[-]+.*$/).test(t);
}
function endsWithHyphen(t) {
	return new RegExp(/^.*[-]+$/).test(t);
}

function removeNonAlphabetOrDigits(t) {
	if (!isStringOrNumber(t)) return '';
	const notNumsChars = new RegExp(/[^0-9a-zA-Z]/g);
	const str = isString(t) ? t : t.toString();
	return str.replace(notNumsChars, '');
}

function removeNonEmailCharacters(t) {
	if (!isString(t)) return '';
	const nonEmailTokens = new RegExp(/[^a-zåäöA-ZÅÄÖ0-9" @.!#$%'*+-/=?^_`{|}~]/g);
	return t.replace(nonEmailTokens, '');
}

function removeNonDigits(t) {
	const notNumsChars = new RegExp(/[^0-9]/g);
	if (!isStringOrNumber(t)) return '';
	const str = isString(t) ? t : t.toString();
	return str.replace(notNumsChars, '');
}
function removeNonCharsKeepSpace(t) {
	if (!isStringOrNumber(t)) return '';
	const str = isString(t) ? t : t.toString();
	const nonCharsButSpace = /[^a-z A-Z]/g;
	return str.replace(nonCharsButSpace, '');
}

function replaceNonBreakingSpace(str) {
	// replace nbsp (non-breaking-space) with normal space
	// charCode 160 with 32 normal space
	/* eslint-disable no-irregular-whitespace */
	// "above 100,00 kr".charCodeAt(12) === 160  nbsp non-breaking-space
	/* eslint-enable no-irregular-whitespace */
	const L = str && str.length;
	if (!L) {
		return '';
	}
	const replaced = [];
	for (let i = 0; i < L; i += 1) {
		replaced[i] = str[i].charCodeAt(0) === 160 ? ' ' : str[i];
	}
	return replaced.join('');
}

function limitLength(str, max = 0) {
	if (!isString(str)) return '';
	return str.substring(0, max);
}

function trimStringPrefix(t, len = 0) {
	if (!isStringOrNumber(t)) return '';
	const str = typeof t === 'string' ? t : t.toString();
	return str.substring(str.length - len);
}

function localPart(email) {
	if (!isString(email)) return '';
	return email.substring(0, email.lastIndexOf('@'));
}
function domainPart(email) {
	if (!isString(email)) return '';
	return email.substring(email.lastIndexOf('@') + 1);
}
function removeSpace(str) {
	// TODO add unit test to confirm functionality!!
	// remove one or more spaces from beginning and end
	// const trailspace = new RegExp(/^[\s]+|[\s]+$/g);
	const trailspace = new RegExp(/[\s]/g);
	return str && str.replace ? str.replace(trailspace, '') : '';
}
function restrictMaxLength(t) {
	// '234' gives '23'
	// '2' gives 2
	// null gives ''
	const str = (t || t === 0) && t.toString ? t.toString() : null;
	const first = str && str[0] ? str[0] : '';
	const second = str && str[1] ? str[1] : '';
	const twoDigitStr = `${first}${second}`;
	return twoDigitStr;
}
function lastCharacters(t, num = 4) {
	// '***********1234' is converted to '1234'
	// 'abcEfgh' is converted to 'Efgh'
	// 'abc' is returned as it is for 'num>str.length'
	// accepts strings and numbers
	if (isNullOrUndefined(t)) return '';
	if (!isString(t)) {
		throw new Error(`string-num-clean: last character: can only extract last characters from strings: ${t}`);
	}
	if (!Number.isInteger(num)) {
		throw new Error(`string-num-clean: last character: specify last characters with an integer: ${t}`);
	}
	// handle a negative numeric input
	const lastFour = -Math.abs(num);
	return t.slice(lastFour);
}
function filterAwayNonDigits(str) {
	/* filter away all but 0-9 */
	const nonDigitStr = str && str.replace ? str.replace(/[^(0-9)]/g, '') : '';
	return nonDigitStr;
}

function hasDecimalPoint(t) {
	const str = (t || t === 0) && t.toString ? t.toString() : null;
	return str && str.match ? str.match(/[.]+/g) : false;
}

/**
 * [notZeros validate input to not evaluate to zero:
 * return false for 0, '0', '0000'
 * ]
 * @param  {[type]} t [string|number]
 * @return {[type]}   [Boolean]
 */
function isZero(t) {
	if (!isStringOrNumber(t)) throw new Error('string-num-clean: only accept input of type string or number');
	const num = isString(t) ? parseInt(t, 10) : t;
	return num === 0;
}

function ConvertToDecimal(t) {
	const normalizedValue = t.includes(',') ? t.replace(',', '.') : t;
	const result = parseFloat(normalizedValue);
	return Number.isNaN(result) ? 0 : result;
}

function toDigitsAndDecimalPoint(t) {
	/* filter away all but a decimal number from a string
	No rounding is done. More than two decimals are ignored.
	append the period if it was input
	if '23.' is input, return '23'.
	if '23' is input, return '23'
	if '23.109' is input, return '23.10'
	*/
	const str = (t || t === 0) && t.toString ? t.toString() : null;
	const containsDecimal = hasDecimalPoint(t);
	const arr = str && str.split && str.split('.');
	const first = arr && arr[0];
	const second = arr && arr[1];
	const nospaceFirst = removeSpace(first);
	const nospaceSecond = removeSpace(second);
	const onlyDigitsFirst = filterAwayNonDigits(nospaceFirst);
	const onlyDigitsSecond = filterAwayNonDigits(nospaceSecond);
	const secondOnlyTwo = restrictMaxLength(onlyDigitsSecond);
	let noLeadingZeros = parseInt(onlyDigitsFirst, 10) || 0;
	noLeadingZeros = noLeadingZeros.toString ? noLeadingZeros.toString() : '0';
	const asdecimal = containsDecimal ? `${noLeadingZeros}.${secondOnlyTwo}` : `${noLeadingZeros}`;
	return asdecimal;
}

/**
 * [stringToNumber convert numeric strings to float number]
 * @param  {[string|number]} value [null or undefined values are rejected]
 * @return {[Number]}       [description]
 */
function stringToNumber(value) {
	if (isNullOrUndefined(value)) {
		throw new Error('string-num-clean: stringToNumber: only accepts defined input');
	}
	if (!isStringOrNumber(value)) {
		throw new Error('string-num-clean: stringToNumber: only accepts input of type string or number');
	}
	const convertedValue = parseFloat(value);
	return convertedValue;
}
export {
	beginsWithHyphen,
	containsOnlyDigits,
	containsOnlyDigitsOrLetters,
	containsOnlyLetters,
	doesNotContainNonLatinCodepoints,
	domainPart,
	endsWithHyphen,
	hasTwoWords,
	hasGreekCurrencyFormat,
	isNullOrUndefined,
	isNumber,
	isString,
	isStringOrNumber,
	hasStringLengthOf,
	hasStringLengthMinMax,
	lastCharacters,
	limitLength,
	trimStringPrefix,
	localPart,
	isZero,
	removeNonAlphabetOrDigits,
	removeNonDigits,
	removeNonEmailCharacters,
	removeNonCharsKeepSpace,
	removeSpace,
	replaceNonBreakingSpace,
	stringToNumber,
	filterAwayNonDigits,
	restrictMaxLength,
	hasDecimalPoint,
	toDigitsAndDecimalPoint,
	twoOrNoDecimals,
	ConvertToDecimal
};
